import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupClient = () => {
  const { t } = useTranslation();

  return {
    name: Yup.string().required(
      t("validation.required", {
        name: t("page.name"),
      })
    ),
    phoneNumber: Yup.string().required(
      t("validation.required", {
        phoneNumber: t("page.phoneNumber"),
      })
    ),
    state: Yup.string().required(
      t("validation.required", {
        state: t("page.state"),
      })
    ),
    township: Yup.string().required(
      t("validation.required", {
        township: t("page.township"),
      })
    ),
    dateOfBirth: Yup.string().required(
      t("validation.required", {
        dateOfBirth: t("page.dateOfBirth"),
      })
    ),
    noOfChildren: Yup.number().required(
      t("validation.required", {
        dateOfBirth: t("page.dateOfBirth"),
      })
    ),
    geastralMonth: Yup.number().required(
      t("validation.required", {
        geastralMonth: t("page.geastralMonth"),
      })
    ),
    referredBy: Yup.array().required(
      t("validation.required", {
        referredBy: t("page.referredBy"),
      })
    ),
    gestational_age_of_1_st_AN_care_visit: Yup.string().required(
      t("validation.required", {
        referredBy: t("page.gestational_age_of_1_st_AN_care_visit"),
      })
    ),
    total_numbers_of_AN_care_visit: Yup.string().required(
      t("validation.required", {
        referredBy: t("page.total_numbers_of_AN_care_visit"),
      })
    ),
  };
};
